"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const RawHTML = ({ html, }) => {
    const divRef = (0, react_1.useRef)(null);
    // This trick will get stuff in script tags working.
    // Inspired by conversations at https://stackoverflow.com/questions/35614809/react-script-tag-not-working-when-inserted-using-dangerouslysetinnerhtml
    (0, react_1.useEffect)(() => {
        if (!html)
            return;
        if (divRef.current) {
            const slotHtml = document.createRange().createContextualFragment(html); // Create a 'tiny' document and parse the html string
            // @ts-ignore
            divRef.current.innerHTML = ''; // Clear the container
            // @ts-ignore
            divRef.current.appendChild(slotHtml); // Append the new content
            // @ts-ignore
            divRef.current.replaceWith(...Array.from(divRef.current.childNodes)); // get rid of the wrapping div
        }
    }, [html]);
    return html ? react_1.default.createElement("div", { ref: divRef }) : null;
};
exports.default = RawHTML;
